<template>
    <div class="kas-kecil-upload-box">
        <div class="mb-2">
            <h6 class="form-title mb-2">{{ title }}</h6>
            <b-button variant="pgiBtn" size="sm" @click="$emit('add-photo')">
                <i class="fa fa-plus mr-1"></i>Tambah
            </b-button>
        </div>
        <div
            v-for="photo in photos"
            :key="photo.index"
            class="kas-kecil-upload-item"
        >
            <div class="upload-gadai-btn-wrapper">
                <b-button
                    v-if="photo.publicUrl"
                    class="upload-gadai-btn"
                    variant="cancelBtn"
                    @click="$emit('preview-photo', photo)"
                >
                    Lihat
                </b-button>
                <div class="browse-foto upload-gadai-btn">
                    <b-form-file
                        v-model="photo.file"
                        :state="Boolean(photo.file)"
                        :disabled="photo.isUploading"
                        accept=".pdf,application/pdf,image/*"
                        drop-placeholder="Drop file here..."
                        class="hide-upload-label"
                        @input="file => $emit('upload-photo', { photo, file })"
                    />
                    <b-button
                        variant="cancelBtn"
                        class="upload-gadai-btn"
                        :disabled="photo.isUploading"
                    >
                        <b-spinner v-if="photo.isUploading" small class="mr-1" />
                        <i v-else class="fa fa-upload mr-1"></i>
                        Upload
                    </b-button>
                </div>
            </div>
            <small v-if="photo.fileName" class="text-muted d-block mt-2">{{ photo.fileName }}</small>
            <b-button
                variant="dynamicDeleteBtn"
                class="kas-kecil-photo-remove"
                @click="$emit('remove-photo', photo.index)"
            >
                <i class="fa fa-times"></i>
            </b-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "kas-kecil-upload-photo-box",
    props: {
        title: { type: String, default: "" },
        photos: { type: Array, default: () => [] },
    },
}
</script>

<style scoped>
.kas-kecil-upload-box {
    border: 1px solid #e4e7ea;
    border-radius: 4px;
    padding: 12px;
    height: auto;
}

.form-title {
    color: #1f4e89;
    font-weight: 700;
    margin-bottom: 12px;
}

.kas-kecil-upload-box ::v-deep .form-group > legend {
    display: none;
}

.kas-kecil-upload-box ::v-deep .row > [class*="col-"] {
    flex: 0 0 100%;
    max-width: 100%;
}

.kas-kecil-upload-box ::v-deep .form-dynamic-wrapper {
    margin-bottom: 0 !important;
}

.kas-kecil-upload-item {
    border: 1px solid #e4e7ea;
    border-radius: 4px;
    margin-top: 12px;
    padding: 12px 48px 12px 12px;
    position: relative;
}

.kas-kecil-photo-remove {
    position: absolute;
    right: 10px;
    top: 10px;
}

.upload-gadai-btn-wrapper {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.upload-gadai-btn {
    min-width: 96px;
}

.browse-foto {
    position: relative;
}

.browse-foto .custom-file {
    cursor: pointer;
    height: 34px;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 2;
}
</style>
